import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
// import { amazonVisitHistoryFixture } from "./amazonVisitHistoryFixture";
export interface AmazonVisitHistoryResponse {
  treatmentPlanSummaries: TreatmentPlanSummary[];
}

export interface TreatmentPlanSummary {
  treatmentPlanDateTime?: string;
  providerName?: string;
  prescriptions: TreatmentPlanPrescription[];
  patientInstructions?: string;
  condition?: string;
  conditionCode?: string;
}

export interface TreatmentPlanPrescription {
  medicationName: string;
  sig?: string;
  dispenseQuantity?: number;
  dispenseQuantityUnit?: string;
  daysSupply?: number;
  refills?: number;
  authoredOn?: string;
}

export const useAmazonVisitHistory = ({
  patientId,
  enabled,
}: {
  patientId: string;
  enabled: boolean;
}) => {
  return useApi<AmazonVisitHistoryResponse>({
    queryOptions: {
      queryKey: QueryKeys.Patient.Chart.AmazonVisitHistory.DEFAULT(patientId),
      queryFn: async () => {
        // Comment out below to use fixture for local development
        const response = await axiosInstance.get(
          "amazon-clinic/visits/visit-history",
          {
            params: {
              patientId,
            },
          },
        );
        return response.data;
        // return amazonVisitHistoryFixture;
      },
      enabled: enabled && Boolean(patientId),
    },
  });
};
